// A cor de quem está com a conversa, num lugar só: a IA em violeta, o disparo no
// rosa, a pessoa em laranja e quem espera em âmbar. Os tokens moram em _woot.scss e
// os aliases quem-* em tailwind.config.js.
//
// As classes vão escritas por inteiro, porque o Tailwind só gera o que lê no fonte
// (este arquivo está no glob dele). O canvas não lê classe: `chart` é o token que o
// gráfico lê já resolvido, e `fallback` a cor de quando ele não chega.
//
// Cor nunca sozinha: rosa e laranja têm luminância quase igual (razão 1,07), então
// toda cor daqui vai com rótulo ou legenda.
export const QUEM_CORES = Object.freeze({
  ia: Object.freeze({
    bg: 'bg-quem-ia',
    fill: 'fill-quem-ia',
    chart: '--pz-chart-series-ai',
    fallback: '#6e56cf',
  }),
  disparo: Object.freeze({
    bg: 'bg-quem-disparo',
    fill: 'fill-quem-disparo',
    chart: '--pz-chart-series-outbound',
    fallback: '#ff13f0',
  }),
  pessoa: Object.freeze({
    bg: 'bg-quem-pessoa',
    fill: 'fill-quem-pessoa',
    chart: '--pz-chart-series-person',
    fallback: '#ef5f00',
  }),
  espera: Object.freeze({
    bg: 'bg-quem-espera',
    fill: 'fill-quem-espera',
    chart: '--pz-chart-series-waiting',
    fallback: '#ffc53d',
  }),
});
